import { styled } from "styled-components";

const StyledDiv = styled.div`
  padding: 20px;
`;

export { StyledDiv };
